import Title from "../../components/common/title/Title";
import { useEffect, useRef, useState } from "react";
import { postApi } from "../../services/api/globalApi";
import { Formik, Form } from "formik";
import Input from "../../components/common/inputs/Input";
import Button from "../../components/common/button/Button";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import ImagesModal from "../../components/common/modals/imgaes-modal/ImagesModal";
import { fileUrl } from "../../services/config";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { RxDragHandleDots2 } from "react-icons/rx";

function ImagePickerField({ label, hint, value, onOpen, onClear }) {
  return (
    <div>
      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        {label}
      </label>
      {value ? (
        <div className="bg-gray-50 border border-gray-300 rounded-lg p-3 dark:bg-gray-700 dark:border-gray-600">
          <div className="flex flex-col sm:flex-row sm:items-center gap-3">
            <div className="w-14 h-14 rounded-lg overflow-hidden border border-gray-200 dark:border-gray-500 flex-shrink-0">
              <img
                src={`${fileUrl}files/thumb_${value}`}
                className="w-full h-full object-cover"
                alt=""
              />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900 dark:text-white truncate">
                {value}
              </p>
            </div>
            <div className="flex gap-2">
              <button
                type="button"
                onClick={onOpen}
                className="px-3 py-1.5 text-xs font-medium text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 dark:bg-blue-900/30 dark:text-blue-400 dark:hover:bg-blue-900/50"
              >
                تغییر
              </button>
              <button
                type="button"
                onClick={onClear}
                className="px-3 py-1.5 text-xs font-medium text-red-600 bg-red-50 rounded-lg hover:bg-red-100 dark:bg-red-900/30 dark:text-red-400 dark:hover:bg-red-900/50"
              >
                حذف
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div
          onClick={onOpen}
          className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg p-6 text-center cursor-pointer hover:border-blue-400 hover:bg-blue-50/50 transition-colors dark:bg-gray-700 dark:border-gray-600 dark:hover:border-blue-500 dark:hover:bg-blue-900/20"
        >
          <div className="flex flex-col items-center">
            <svg
              className="w-8 h-8 text-gray-400 mb-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              کلیک کنید برای انتخاب عکس
            </p>
          </div>
        </div>
      )}
      {hint && (
        <p className="mt-1.5 text-xs text-gray-400 dark:text-gray-500">{hint}</p>
      )}
    </div>
  );
}

function SortableSlideItem({ item, index, onRemove, onEdit }) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <tr
      ref={setNodeRef}
      style={style}
      className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
    >
      <td className="px-2 sm:px-4 py-3">
        <button
          {...attributes}
          {...listeners}
          type="button"
          className="cursor-grab text-gray-500 hover:text-gray-700"
        >
          <RxDragHandleDots2 size={18} />
        </button>
      </td>
      <td className="px-2 sm:px-4 py-3">
        {item.image && (
          <img
            src={`${fileUrl}files/thumb_${item.image}`}
            className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg object-cover"
            alt=""
          />
        )}
      </td>
      <td className="px-2 sm:px-4 py-3">
        {item.imageDesktop ? (
          <img
            src={`${fileUrl}files/thumb_${item.imageDesktop}`}
            className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg object-cover"
            alt=""
          />
        ) : (
          <span className="text-xs text-gray-400">—</span>
        )}
      </td>
      <td className="px-2 sm:px-4 py-3 text-xs sm:text-sm max-w-[100px] sm:max-w-none truncate">
        {item.link || "-"}
      </td>
      <td className="px-2 sm:px-4 py-3 text-center">{index + 1}</td>
      <td className="px-2 sm:px-4 py-3">
        <div className="flex gap-1 sm:gap-2">
          <button
            onClick={() => onEdit(index)}
            className="text-xs sm:text-sm font-medium text-blue-600 dark:text-blue-500 hover:underline"
          >
            ویرایش
          </button>
          <button
            onClick={() => onRemove(index)}
            className="text-xs sm:text-sm font-medium text-red-600 dark:text-red-500 hover:underline"
          >
            حذف
          </button>
        </div>
      </td>
    </tr>
  );
}

export default function Slider() {
  const [slides, setSlides] = useState([]);
  const [name, setName] = useState(null);
  const [part, setPart] = useState(null);
  const [position, setPosition] = useState(null);
  const imagesModal = useRef();
  const imagesModalDesktop = useRef();
  const [image, setImage] = useState("");
  const [imageDesktop, setImageDesktop] = useState("");
  const [editIndex, setEditIndex] = useState(null);

  const { utils } = useSelector(utilsState);
  const sensors = useSensors(useSensor(PointerSensor));

  const formHandler = (values, { resetForm }) => {
    if (!image) {
      warningMessage("لطفا برای اسلایدر عکس انتخاب کنید");
      return;
    }

    if (editIndex !== null) {
      setSlides((prev) =>
        prev.map((item, i) =>
          i === editIndex
            ? { ...values, image, imageDesktop: imageDesktop || null, id: item.id }
            : item
        )
      );
      setEditIndex(null);
      setImage("");
      setImageDesktop("");
      resetForm();
      successMessage("اسلاید با موفقیت ویرایش شد");
    } else {
      const newValues = {
        ...values,
        image,
        imageDesktop: imageDesktop || null,
        id: new Date().getTime(),
      };
      setSlides((prev) => {
        if (!Array.isArray(prev)) return [newValues];
        return [...prev, newValues];
      });
      setImage("");
      setImageDesktop("");
      resetForm();
    }
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over?.id) {
      const oldIndex = slides.findIndex((item) => item.id === active.id);
      const newIndex = slides.findIndex((item) => item.id === over?.id);
      setSlides((slides) => arrayMove(slides, oldIndex, newIndex));
    }
  };

  const deleteSlide = (index) => {
    let newSlides = [...slides];
    newSlides.splice(index, 1);
    setSlides(newSlides);
    if (editIndex === index) {
      setEditIndex(null);
      setImage("");
      setImageDesktop("");
    }
  };

  const editSlide = (index) => {
    setEditIndex(index);
    setImage(slides[index].image);
    setImageDesktop(slides[index].imageDesktop || "");
  };

  const selectedImages = (item) => {
    if (item) {
      setImage(item.name);
      successMessage("عکس اضافه شد.");
    }
  };

  const selectedImagesDesktop = (item) => {
    if (item) {
      setImageDesktop(item.name);
      successMessage("عکس دسکتاپ اضافه شد.");
    }
  };

  const navigate = useNavigate();

  const handleSlider = async () => {
    if (name?.length && slides?.length) {
      const path = "admin/sliders";
      const slidesWithPriority = slides.map((slide, index) => ({
        ...slide,
        priority: index + 1,
      }));
      const body = {
        name,
        part,
        position,
        slides: slidesWithPriority,
      };
      try {
        await postApi({ path, body });
        successMessage("اسلایدر با موفقیت ویرایش شد.");
        navigate("/slider-list");
      } catch (error) {
        console.log(error);
        errorMessage(error?.response?.data?.errors[0].message);
      }
    } else {
      warningMessage("لطفا مقادیر ورودی را کنترل کنید.");
    }
  };

  const location = useLocation();

  useEffect(() => {
    if (location?.state?.name) {
      setName(location?.state?.name);
      setPosition(location?.state?.position);
      setPart(location?.state?.part);
      const slidesWithIds = (location?.state?.slides || []).map((slide) => ({
        ...slide,
        id: slide.id || Math.floor(Math.random() * 100000),
      }));
      setSlides(slidesWithIds);
    }
  }, [location?.state]);

  useEffect(() => {
    if (location.pathname === "/add-slider") {
      reset();
    }
  }, [location.pathname]);

  const reset = () => {
    setName("");
    setPosition("");
    setPart("");
    setSlides([]);
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6 relative">
      <Title title={"مدیریت اسلایدر"} />
      <div className="grid sm:grid-cols-2 gap-4 mt-4">
        <div className="w-full">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            نام
          </label>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          />
        </div>

        <div>
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            بخش
          </label>
          <select
            value={part}
            onChange={(e) => setPart(e.target.value)}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value={""}>انتخاب بخش</option>
            {utils?.SLIDER_PART_VALUES?.length
              ? utils?.SLIDER_PART_VALUES?.map((item) => {
                  return <option value={item.value}>{item.name}</option>;
                })
              : null}
          </select>
        </div>
        <div>
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            موقعیت
          </label>
          <select
            value={position}
            onChange={(e) => setPosition(e.target.value)}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value={""}>انتخاب موقعیت</option>
            {utils?.SLIDER_POSITION_VALUES?.length
              ? utils?.SLIDER_POSITION_VALUES?.map((item) => {
                  return <option value={item.value}>{item.name}</option>;
                })
              : null}
          </select>
        </div>
      </div>
      <div className="mt-6">
        <Title title={"افزودن اسلاید"} />
        <div className="mt-4">
          <Formik
            enableReinitialize
            initialValues={{
              link: editIndex !== null ? slides[editIndex]?.link || "" : "",
            }}
            onSubmit={formHandler}
          >
            <Form>
              <div className="mb-4">
                <Input
                  name="link"
                  placeholder="لینک"
                  label="لینک"
                  type="text"
                />
              </div>
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <ImagePickerField
                  label="عکس (موبایل)"
                  hint="در حالت موبایل و تبلت نمایش داده می‌شود."
                  value={image}
                  onOpen={() => imagesModal.current.showModal()}
                  onClear={() => setImage("")}
                />
                <ImagePickerField
                  label="عکس (دسکتاپ)"
                  hint="اختیاری — مخصوص نمایشگرهای بزرگ. اگر خالی بماند، همان عکس موبایل استفاده می‌شود."
                  value={imageDesktop}
                  onOpen={() => imagesModalDesktop.current.showModal()}
                  onClear={() => setImageDesktop("")}
                />
              </div>
              <div className="flex flex-wrap gap-3 mt-6">
                <Button
                  text={editIndex !== null ? "ویرایش اسلاید" : "افزودن اسلاید"}
                  color={"primary"}
                />
                {editIndex !== null && (
                  <Button
                    text="انصراف"
                    color="danger"
                    onClick={() => {
                      setEditIndex(null);
                      setImage("");
                      setImageDesktop("");
                    }}
                    type="button"
                  />
                )}
              </div>
            </Form>
          </Formik>
        </div>
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg mt-6">
          {slides?.length ? (
            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragEnd={handleDragEnd}
            >
              <table className="w-full text-xs sm:text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                  <tr>
                    <th
                      scope="col"
                      className="px-2 sm:px-4 py-2 sm:py-3 w-8"
                    ></th>
                    <th scope="col" className="px-2 sm:px-4 py-2 sm:py-3">
                      عکس (موبایل)
                    </th>
                    <th scope="col" className="px-2 sm:px-4 py-2 sm:py-3">
                      عکس (دسکتاپ)
                    </th>
                    <th scope="col" className="px-2 sm:px-4 py-2 sm:py-3">
                      لینک
                    </th>
                    <th
                      scope="col"
                      className="px-2 sm:px-4 py-2 sm:py-3 text-center w-16"
                    >
                      اولویت
                    </th>
                    <th scope="col" className="px-2 sm:px-4 py-2 sm:py-3">
                      عملیات
                    </th>
                  </tr>
                </thead>
                <SortableContext
                  items={slides.map((item) => item.id)}
                  strategy={verticalListSortingStrategy}
                >
                  <tbody>
                    {slides?.map((item, index) => (
                      <SortableSlideItem
                        key={item.id}
                        item={item}
                        index={index}
                        onRemove={deleteSlide}
                        onEdit={editSlide}
                      />
                    ))}
                  </tbody>
                </SortableContext>
              </table>
            </DndContext>
          ) : (
            <div className="w-full flex items-center justify-center my-3 py-2 dark:text-white">
              <p>هیچ اسلایدی هنوز ساخته نشده است.</p>
            </div>
          )}
        </div>
      </div>
      <div className="flex flex-col gap-y-2">
        <div className="mt-6">
          <Button
            onClick={handleSlider}
            text={location?.state ? "ویرایش اسلایدر" : "افزودن اسلایدر"}
            color={"success"}
            type="button"
          />
        </div>
      </div>
      <ImagesModal selectedImages={selectedImages} ref={imagesModal} />
      <ImagesModal
        selectedImages={selectedImagesDesktop}
        ref={imagesModalDesktop}
      />
    </div>
  );
}
